import { pages } from '@app/util/links'

export type MegaMenuLink = {
  label: string
  url: string
}

export enum MobileMenuPage {
  'main',
  'find',
  'start',
  'learn',
  'aboutUs',
}

// Centralized route definitions for mega menu
export const MegaMenuLinks = {
  // Discover section routes
  discover: pages.discover,
  discoverPlots: pages.plots,
  discoverInitiatives: pages.initiatives,
  discoverInitiativesLiving: pages.initiativesWithApplyPhase('living'),
  discoverServiceProviders: pages.serviceProviders,

  // Main content routes
  blog: pages.blogs('verhalen'),
  knowledgeHub: pages.knowledgeHub,
  elearning: pages.elearning,
  aboutUs: pages.aboutUs,
  stewardOwnership: pages.stewardOwnership,
  // joinUs: externalPages.jobs,
  events: pages.events,

  // Start section routes
  startInitiative: pages.dashboardStartInitiative,
  startInitiativeArticle:
    pages.knowledgeHubModule('je-account-project') + '?slug=project-aanmaken',
  startGroupArticle:
    pages.knowledgeHubModule('je-account-project') + '?slug=woongroep-aanmaken',
  startDeveloperArticle:
    pages.knowledgeHubModule('je-account-project') +
    '?slug=crowdbuilding-voor-professionals',

  // Learn section routes
  whoWorksArticle: pages.knowledgeHubModule(
    'je-account-project?slug=hoe-werkt-crowdbuilding',
  ),
  whowToMakeAccountArticle: pages.knowledgeHubModule(
    'je-account-project?slug=account-maken',
  ),
  howtoStartProjectArticle: pages.knowledgeHubModule(
    'je-account-project?slug=project-aanmaken',
  ),

  // Find section routes
  regions: pages.regions,
  housingForms: pages.housingForms,

  // Government section routes
  municipalities: pages.forMunicipalities,
  experts: pages.forExperts,

  // Legacy (to be updated)
  contactUs: pages.contactUs,
  legal: pages.legal,
}
